/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  // ========== 套餐模块变量（提前声明） ==========
  var _imgIndex = 0 // 当前图片索引 (0-7)
  var _imagesPerGroup = 4 // 每组4张图片
  var _totalImages = 8 // 总共8张图片

  // 更新产品图片显示（PC端和移动端）
  function updateProductDisplay() {
    // PC端
    $('.product-part.sp-pc .sp-pro-imgs>img')
      .removeClass('active')
      .eq(_imgIndex)
      .addClass('active')
    $('.product-part.sp-pc .sp-scroll-img>img')
      .removeClass('active')
      .eq(_imgIndex)
      .addClass('active')
    // 移动端
    $('.product-part.sp-mobile .sp-pro-imgs>img')
      .removeClass('active')
      .eq(_imgIndex)
      .addClass('active')
    $('.product-part.sp-mobile .sp-scroll-img>img')
      .removeClass('active')
      .eq(_imgIndex)
      .addClass('active')
  }

  // 更新缩略图滚动位置（PC端和移动端）
  function updateScrollPosition() {
    // 根据当前图片索引决定显示哪组（0-3显示第一组，4-7显示第二组）
    var currentGroup = Math.floor(_imgIndex / _imagesPerGroup)
    // PC端：170px高度 + 5px间距
    var pcScrollOffset = currentGroup * _imagesPerGroup * (170 + 5)
    $('.product-part.sp-pc .sp-scroll-img').css(
      'transform',
      'translateY(-' + pcScrollOffset + 'px)'
    )
    // 移动端：220px高度 + 5px间距
    var mobileScrollOffset = currentGroup * _imagesPerGroup * (220 + 5)
    $('.product-part.sp-mobile .sp-scroll-img').css(
      'transform',
      'translateY(-' + mobileScrollOffset + 'px)'
    )
  }

  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  // let spImgList = [
  //   "./image/202512042-p1.png",
  //   "./image/202512042-p2.png",
  //   "./image/202512042-p3.png",
  //   "./image/202512042-p4.png",
  //   "./image/202512042-p5.png",
  //   "./image/202512042-p6.png",
  //   "./image/202512042-p7.png",
  //   "./image/202512042-b1.png",
  //   "./image/202512042-b2.png",
  // ];

  // 顶部文字轮播
  new Swiper('.sp-swiper-fade', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 3000,
    },
    speed: 1000,
    loop: true,
  })

  // // 按钮轮播
  // new Swiper(".sp-btn-loop", {
  //   spaceBetween: 10,
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //     reverseDirection: true,
  //   },
  //   loop: true,
  // });

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      // delay: 0,
    },
    // speed: 6000,
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.sp-swiper-btn-next',
      prevEl: '.sp-swiper-btn-prev',
    },
  })

  new Swiper('.sp-swiper2-m', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.sp-swiper-btn-next-m',
      prevEl: '.sp-swiper-btn-prev-m',
    },
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 0,
  })
  let sptextList = ['X2', '', 'X2']
  let prods = window.product
  function getCur(boxDom) {
    let type = boxDom.find('.sp-color .active').data('val')
    let cur = prods.find(item => item.option1 == type)
    let num = boxDom.find('#calcNumber').val()
    let price = ((cur.price * num) / 100).toFixed(2)
    let compare_at_price = ((cur.compare_at_price * num) / 100).toFixed(2)
    return { cur, price, compare_at_price, num }
  }
  $(' .sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $(' .sp-color .sp-option.active').index()
    // let numOptions = $(" .sp-num .sp-option.active").index();
    // let typeOptions = $(" .sp-type .sp-option.active").index();

    // if (typeOptions > 0) {
    //   $(".sp-img-pro").show();
    // } else {
    //   $(".sp-img-pro").hide();
    // }

    // $(".sp-num-tip").text(sptextList[numOptions]);

    // // 如果是颜色选项，更新产品图片
    if ($(this).closest('.sp-color').length > 0) {
      var colorIndex = $(this).index()
      if (
        typeof _imgIndex !== 'undefined' &&
        typeof _totalImages !== 'undefined'
      ) {
        _imgIndex = colorIndex < _totalImages ? colorIndex : 0
        if (typeof updateProductDisplay === 'function') {
          updateProductDisplay()
        }
        if (typeof updateScrollPosition === 'function') {
          updateScrollPosition()
        }
      }
    }
    const { compare_at_price, price } = getCur($(this).closest('.product-part'))
    //   const isMobile = $(this).closest(".product-part").hasClass("sp-mobile")
    calculateTotal()
    $('#sp_price3').text(price)
    $('#sp_price4').text(compare_at_price)
    $('#sp_price1').text(price)
    $('#sp_price2').text(compare_at_price)
    _swiper.slideToLoop(colorOptions)
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // preloadImages(spImgList);

    // 处理所有锚点链接
    var links = document.querySelectorAll('a[href^="#"]')

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为

        var href = this.getAttribute('href')
        var targetId = href.substring(1) // 移除#号

        // 查找目标元素
        var targetElement = null
        if (targetId === 'shopping') {
          targetElement = document.getElementById('shopping')
        } else if (targetId === 'GUARANTEES') {
          targetElement = document.getElementById('GUARANTEES')
        } else if (targetId === 'FAQ') {
          targetElement = document.getElementById('FAQ')
        } else if (targetId === '') {
          // 回到顶部
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
          return
        } else {
          targetElement = document.getElementById(targetId)
        }

        if (targetElement) {
          const offsetTop =
            document.body.clientWidth <= 1080
              ? targetElement.offsetTop -
                ($('.sp-nav').length ? $('.sp-nav').height() : 0)
              : targetElement.offsetTop
          let sptop = document.body.clientWidth <= 1080 ? 0 : 70
          let zoom = $('div#root').css('zoom')

          // PC端减30px，移动端加30px
          let offset = document.body.clientWidth <= 1080 ? 30 : -30
          let finalTop = (offsetTop + offset) * zoom - sptop * zoom

          // 使用多种滚动方法确保兼容性
          window.scrollTo({
            top: finalTop,
            behavior: 'smooth',
          })

          if (typeof $ !== 'undefined') {
            $('html, body').animate(
              {
                scrollTop: finalTop,
              },
              800
            )
          }

          setTimeout(function () {
            document.documentElement.scrollTop = finalTop
            document.body.scrollTop = finalTop
          }, 100)
        }
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  // 从页面获取初始价格
  let originalPrice1 = 11.99 // 单价1的基础价格
  let originalPrice2 = 23.99 // 单价2的基础价格

  // 初始化时获取页面上的价格
  function initializePrices() {
    const price1Element = $('#sp_price1')
    const price2Element = $('#sp_price2')

    if (price1Element.length > 0) {
      originalPrice1 = parseFloat(price1Element.text()) || 11.99
    }
    if (price2Element.length > 0) {
      originalPrice2 = parseFloat(price2Element.text()) || 23.99
    }
  }

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }

  // 减号按钮点击事件
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      // 使用原始单价计算总价
      $('#sp_price1').html(calcTotal(originalPrice1, input.value))
      $('#sp_price2').html(calcTotal(originalPrice2, input.value))
    }
  })

  // 加号按钮点击事件
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    // 使用原始单价计算总价
    $('#sp_price1').html(calcTotal(originalPrice1, input.value))
    $('#sp_price2').html(calcTotal(originalPrice2, input.value))
  })

  // 输入框变化事件
  $('#calcNumber').on('input change', function () {
    let num = Number(this.value)
    if (num > 0) {
      $('#sp_price1').html(calcTotal(originalPrice1, num))
      $('#sp_price2').html(calcTotal(originalPrice2, num))
    }
  })

  // 初始化价格
  initializePrices()

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }
  let spTimer = null
  let spHasShown = false // 防止重复显示

  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop()
    var zoom = parseFloat($('div#root').css('zoom')) || 1

    if (scrollTop > $('.sp_header').height() * zoom) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 滚动添加底部
    if (spHasShown) return // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && scrollTop > 800) {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'flex'
        spHasShown = true // 标记为已显示
      }, 3000)
    }
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  let initNum = 0
  $(document).on('click', '.sp_add_cart', function () {
    // 购物车加购动效

    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)

    // 根据设备类型选择不同的购物车
    if (document.body.clientWidth <= 1080) {
      $('.sp-mobile-sticky-bottom .sp-sticky-cart').addClass('on')
      setTimeout(function () {
        $('.sp-mobile-sticky-bottom .sp-sticky-cart').removeClass('on')
      }, 500)
    } else {
      $('.sp_pc .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp_pc .sp-cart').removeClass('on')
      }, 500)
    }

    let spNum = $('.sp_product_part #calcNumber')[0].value
    initNum += Number(spNum)

    // $("#calcNumber").val(1);

    $('.cardNum').each(function () {
      $(this).html(initNum)
    })
    $('.cardNum').removeClass('sp-gray')
    // handleAddToCart(initNum);

    var imgs = $('.sp_product_part .swiper-slide-active').find('img')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      // 获取zoom值
      var zoom = parseFloat($('div#root').css('zoom')) || 1

      // 使用getBoundingClientRect获取图片在视口中的实际位置
      var imgRect = $img[0].getBoundingClientRect()
      var startTop = imgRect.top / zoom
      var startLeft = imgRect.left / zoom

      $('.sp_product_part').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',
        top: startTop,
        left: startLeft,
        'z-index': 999999,
      })
      let finish
      if (document.body.clientWidth <= 1080) {
        finish = $('.sp-mobile-sticky-bottom .sp-sticky-cart')
        // 底部粘性模块在#root内受zoom缩放，使用getBoundingClientRect获取实际位置
        var cartEl = finish[0]
        var rect = cartEl ? cartEl.getBoundingClientRect() : null
        var targetTop = rect
          ? (rect.top + rect.height / 2) / zoom
          : $(window).height() - 100
        var targetLeft = rect ? (rect.left + rect.width / 2) / zoom : 60

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      } else {
        finish = $('.sp_pc .sp-cart')
        // 使用getBoundingClientRect获取购物车在视口中的实际位置
        var cartEl = finish[0]
        var rect = cartEl ? cartEl.getBoundingClientRect() : null
        var targetTop = rect ? (rect.top + rect.height / 2) / zoom : 50
        var targetLeft = rect
          ? (rect.left + rect.width / 2) / zoom
          : window.innerWidth - 100

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      }
    })
  })

  // 问答
  // 手风琴交互逻辑 (新增)
  $('.sp-qa1-faq-question').on('click', function () {
    var $currentItem = $(this).parent('.sp-qa1-faq-item') // 当前点击的父级
    var $answer = $(this).next('.sp-qa1-faq-answer') // 当前的答案部分
    var $icon = $(this).find('.sp-qa1-faq-icon') // 当前的图标

    // 如果当前已经是打开的，则关闭它
    if ($currentItem.hasClass('active')) {
      $answer.slideUp()
      $currentItem.removeClass('active')
      $icon.removeClass('fa-minus').addClass('fa-plus')
    } else {
      // 如果当前是关闭的：

      // 1. 先关闭所有其他的项 (互斥效果)
      $('.sp-qa1-faq-item').removeClass('active')
      $('.sp-qa1-faq-answer').slideUp()
      $('.sp-qa1-faq-icon').removeClass('fa-minus').addClass('fa-plus')

      // 2. 展开当前项
      $currentItem.addClass('active')
      $answer.slideDown()
      $icon.removeClass('fa-plus').addClass('fa-minus')
    }
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画 - sp-ani2 (从右到左)
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.2,
        rootMargin: '-100px 0px -100px 0px',
      }
    )
    observerAni.observe(gradually3)
  }

  // 文本渐出动画 - sp-ani3 (从左到右)
  const graduallyList4 = document.getElementsByClassName('sp-fade-box')
  for (let gradually4 of graduallyList4) {
    const paragraph4 = gradually4.querySelectorAll('.sp-ani3')

    const observerAni3 = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph4.forEach((span, index) => {
              span.style.animation = `sp-fade-right 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 0.5}s`
            })

            observerAni3.unobserve(gradually4)
          }
        })
      },
      {
        threshold: 0.2,
        rootMargin: '-100px 0px -100px 0px',
      }
    )
    observerAni3.observe(gradually4)
  }

  // 套餐商城轮播功能已移除，只保留颜色选择时小图滚动功能

  // Breathe Easy板块轮播图
  const breatheSwiper = new Swiper('.sp-breathe-swiper', {
    slidesPerView: 3,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp-breathe-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>'
      },
    },
    slideToClickedSlide: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
      },
    },
  })

  // 移动端Breathe Easy轮播图
  const mobileBreathSwiper = new Swiper('.sp-mobile-breathe-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp-mobile-breathe-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>'
      },
    },
    slideToClickedSlide: true,
  })

  // PC端 sp-part2 视频自动播放（已移除播放/暂停按钮）

  // sp-part2 轮播图功能（图片+文字绑定切换）- PC端
  ;(function () {
    const slides = document.querySelectorAll('.sp-part2 .sp-part2-slide')
    const leftArrow = document.querySelector('.sp-part2 .sp-part2-arrow-left')
    const rightArrow = document.querySelector('.sp-part2 .sp-part2-arrow-right')

    if (!slides.length || !leftArrow || !rightArrow) return

    let currentIndex = 0
    const totalSlides = slides.length
    let autoPlayTimer = null

    function showSlide(index) {
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('active')
        } else {
          slide.classList.remove('active')
        }
      })
      currentIndex = index
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % totalSlides
      showSlide(nextIndex)
    }

    function prevSlide() {
      const prevIndex = (currentIndex - 1 + totalSlides) % totalSlides
      showSlide(prevIndex)
    }

    function startAutoPlay() {
      stopAutoPlay()
      autoPlayTimer = setInterval(nextSlide, 4000)
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer)
        autoPlayTimer = null
      }
    }

    leftArrow.addEventListener('click', function () {
      prevSlide()
      startAutoPlay()
    })

    rightArrow.addEventListener('click', function () {
      nextSlide()
      startAutoPlay()
    })

    startAutoPlay()
  })()

  // 移动端 sp-part2 视频自动播放（已移除播放/暂停按钮）

  // 移动端 sp-part2 图片轮播功能
  ;(function () {
    const slides = document.querySelectorAll('.sp-mobile-part2-slide')
    const leftArrow = document.querySelector('.sp-mobile-part2-arrow-left')
    const rightArrow = document.querySelector('.sp-mobile-part2-arrow-right')

    if (!slides.length || !leftArrow || !rightArrow) return

    let currentIndex = 0
    const totalSlides = slides.length
    let autoPlayTimer = null

    function showSlide(index) {
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('active')
        } else {
          slide.classList.remove('active')
        }
      })
      currentIndex = index
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % totalSlides
      showSlide(nextIndex)
    }

    function prevSlide() {
      const prevIndex = (currentIndex - 1 + totalSlides) % totalSlides
      showSlide(prevIndex)
    }

    function startAutoPlay() {
      stopAutoPlay()
      autoPlayTimer = setInterval(nextSlide, 4000)
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer)
        autoPlayTimer = null
      }
    }

    leftArrow.addEventListener('click', function () {
      prevSlide()
      startAutoPlay()
    })

    rightArrow.addEventListener('click', function () {
      nextSlide()
      startAutoPlay()
    })

    startAutoPlay()
  })()

  // 移动端 sp-part4 轮播图功能 - 使用Swiper实现无缝循环
  new Swiper('.sp-mobile-part4-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp-mobile-part4-carousel .sp-mobile-part4-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>'
      },
    },
  })

  // ========== 套餐模块交互功能 ==========
  // 价格配置
  var priceConfig = {
    basePrice: 12.99,
    originalPrice: 59.99,
  }

  // 缩略图点击切换（PC端和移动端）
  $('.sp-scroll-img > img').click(function () {
    _imgIndex = $(this).index()
    updateProductDisplay()
  })

  // 产品图片轮播功能已移除，只保留颜色选择时小图滚动

  // 计算总价（PC端和移动端）
  function calculateTotal() {
    // 移动端
    var mobileQuantity = parseInt($('#calcNumber').val()) || 1
    var mobileTotal = (priceConfig.basePrice * mobileQuantity).toFixed(2)
    $('#sp_price1').text(mobileTotal)
    var mobileOriginalTotal = (
      priceConfig.originalPrice * mobileQuantity
    ).toFixed(2)
    $('#sp_price2').text(mobileOriginalTotal)

    // PC端
    var pcQuantity = parseInt($('#calcNumber2').val()) || 1
    var pcTotal = (priceConfig.basePrice * pcQuantity).toFixed(2)
    $('#sp_price3').text(pcTotal)
    var pcOriginalTotal = (priceConfig.originalPrice * pcQuantity).toFixed(2)
    $('#sp_price4').text(pcOriginalTotal)
  }

  // 数量加减

  $('.addGroup .add').click(function () {
    var input = $(this).siblings('input')
    var val = parseInt(input.val()) || 1
    if (val < 200) {
      input.val(val + 1)
      const { compare_at_price, price } = getCur(
        $(this).closest('.product-part')
      )
      //   const isMobile = $(this).closest(".product-part").hasClass("sp-mobile")
      calculateTotal()
      $('#sp_price3').text(price)
      $('#sp_price4').text(compare_at_price)
      $('#sp_price1').text(price)
      $('#sp_price2').text(compare_at_price)
    }
  })

  $('.addGroup .reduce').click(function () {
    var input = $(this).siblings('input')
    var val = parseInt(input.val()) || 1
    if (val > 1) {
      input.val(val - 1)
      const { compare_at_price, price } = getCur(
        $(this).closest('.product-part')
      )
      //   const isMobile = $(this).closest(".product-part").hasClass("sp-mobile")
      calculateTotal()
      $('#sp_price3').text(price)
      $('#sp_price4').text(compare_at_price)
      $('#sp_price1').text(price)
      $('#sp_price2').text(compare_at_price)
    }
  })

  // 输入框变化时计算总价
  $('#calcNumber2, #calcNumber').on('change input', function () {
    const { compare_at_price, price } = getCur($(this).closest('.product-part'))
    //   const isMobile = $(this).closest(".product-part").hasClass("sp-mobile")
    calculateTotal()
    $('#sp_price3').text(price)
    $('#sp_price4').text(compare_at_price)
    $('#sp_price1').text(price)
    $('#sp_price2').text(compare_at_price)
    // calculateTotal();
  })
  $('.sp-btn-style').on('click', function () {
    const com_product = $(this).closest('.product-part')
    //    const isMobile = com_product.hasClass("sp-mobile")
    const { cur, num } = getCur(com_product)
    window.location.href = '/cart/' + cur.id + ':' + num
  })
  // 加入购物车
  $('.addCerts').click(function () {
    var isPC = $(this).hasClass('sp-pc')
    var quantity = parseInt($('#calcNumber').val()) || 1
    if (isPC) {
      quantity = parseInt($('#calcNumber2').val()) || 1
    }
    const { cur, num } = getCur($(this).closest('.product-part'))
    //   const isMobile = $(this).closest(".product-part").hasClass("sp-mobile")

    // 更新购物车数量
    console.log(cur, num)
    let data = {
      id: cur.id,
      quantity: num,
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          // $('#cardNum').html(result.item_count)
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
          })
          // $('#cardNum').removeClass('sp-gray')
          $('.sp-num').css('background', '#cf0101')
        })
      },
      dataType: 'json',
    })
    // var currentNum = parseInt($('.cardNum').first().html()) || 0;
    // var newNum = currentNum + quantity;
    // $('.cardNum').html(newNum);

    // 改变购物车颜色
    // if (newNum > 0) {
    //   $('.sp-num').css('background', '#cf0101');
    // }

    // 购物车动画 - 根据点击的按钮判断是PC端还是移动端
    var img = isPC
      ? $('.product-part.sp-pc .sp-pro-imgs>img.active')
      : $('.product-part.sp-mobile .sp-pro-imgs>img.active')

    if (img.length > 0) {
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')

      // 将飞行图片添加到#root内
      $('#root').append(flyer)

      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img[0].offsetLeft,
        'z-index': 999999,
        background: '#e7e9ef',
      })

      console.log(
        '图片起始位置(offsetTop/Left) - top:',
        img[0].offsetTop,
        'left:',
        img[0].offsetLeft
      )

      // 根据点击按钮判断目标位置
      var finish, targetTop, targetLeft
      if (isPC) {
        // PC端：飞向顶部购物车
        finish = $('.sp-part1-pc-header .sp-cart')

        console.log('=== PC端购物车动画调试 ===')
        console.log('找到购物车元素数量:', finish.length)

        if (finish.length > 0) {
          // 使用offsetTop/offsetLeft获取未缩放的坐标
          var cartEl = finish[0]

          console.log(
            '购物车offsetTop:',
            cartEl.offsetTop,
            'offsetLeft:',
            cartEl.offsetLeft
          )
          console.log('购物车宽高:', finish.width(), finish.height())

          // 目标位置：购物车中心
          targetTop = cartEl.offsetTop + finish.height() / 2
          targetLeft = cartEl.offsetLeft + finish.width() / 2

          console.log(
            '目标位置(offsetTop/Left) - top:',
            targetTop,
            'left:',
            targetLeft
          )
        } else {
          // 兜底：右上角
          console.log('未找到购物车，使用兜底位置')
          targetTop = 50
          targetLeft = $(window).width() - 100
          console.log(
            '兜底位置 - top:',
            targetTop,
            'left:',
            targetLeft,
            'window.width:',
            $(window).width()
          )
        }

        // PC端购物车抖动效果
        finish.addClass('shake')
        setTimeout(function () {
          finish.removeClass('shake')
        }, 1000)
      } else {
        // 移动端：飞向底部粘性模块的购物车图标
        finish = $('.sp-mobile-sticky-bottom .sp-sticky-cart')

        if (finish.length > 0) {
          var cartRect = finish[0].getBoundingClientRect()
          targetTop = cartRect.top + cartRect.height / 2
          targetLeft = cartRect.left + cartRect.width / 2
        } else {
          targetTop = $(window).height() - 100
          targetLeft = 60
        }

        // 移动端购物车抖动效果
        finish.addClass('shake')
        setTimeout(function () {
          finish.removeClass('shake')
        }, 1000)
      }

      // 飞入动画
      $('.clone').animate(
        {
          top: targetTop,
          left: targetLeft,
          width: 50,
          height: 50,
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          // 消失动画
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    }
  })

  // Buy Now按钮点击 - 不触发购物车动画，只跳转
  // $('.product-part .sp-btn-style').click(function() {
  //   // 触发加入购物车
  //   if ($(this).closest('.sp-pc').length > 0) {
  //     $('.product-part.sp-pc .addCart').trigger('click');
  //   } else {
  //     $('.product-part.sp-mobile .addCart').trigger('click');
  //   }
  // });

  // QA3 FAQ 手风琴交互
  $('.sp-qa3-question').on('click', function () {
    var $currentItem = $(this).closest('.sp-qa3-item')
    var $answer = $currentItem.find('.sp-qa3-answer')

    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
    } else {
      $('.sp-qa3-item').removeClass('active')
      $('.sp-qa3-answer').slideUp(300)
      $currentItem.addClass('active')
      $answer.slideDown(300)
    }
  })

  // 移动端底部悬浮模块 - 滑过首屏后显示
  ;(function () {
    var el = document.querySelector('.sp-mobile-sticky-bottom')
    if (!el) return

    // 获取#root元素，滚动可能发生在这里
    var root = document.getElementById('root')

    var check = function () {
      var w = window.innerWidth
      // 尝试多种方式获取滚动位置
      var s =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      // 如果root存在，也检查root的滚动位置
      if (root && root.scrollTop > 0) {
        s = root.scrollTop
      }
      // 获取首屏高度（视口高度）
      var firstScreenHeight = window.innerHeight

      if (w <= 1080) {
        el.style.display = 'block'
        // 滑过首屏后显示
        if (s > firstScreenHeight) {
          el.classList.add('show')
        } else {
          el.classList.remove('show')
        }
      } else {
        el.style.display = 'none'
      }
    }

    // 监听多个滚动源
    window.addEventListener('scroll', check, true)
    document.addEventListener('scroll', check, true)
    if (root) {
      root.addEventListener('scroll', check, true)
    }
    window.addEventListener('resize', check)
    setInterval(check, 500) // 每500ms检查一次作为备用
    check()
  })()
})
